import { render, staticRenderFns } from "./de-investors.vue?vue&type=template&id=2529d252&"
import script from "./de-investors.vue?vue&type=script&lang=js&"
export * from "./de-investors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2529d252')) {
      api.createRecord('2529d252', component.options)
    } else {
      api.reload('2529d252', component.options)
    }
    module.hot.accept("./de-investors.vue?vue&type=template&id=2529d252&", function () {
      api.rerender('2529d252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/conversion-2023/de-investors.vue"
export default component.exports